import { createContext, useContext } from 'react'

export const DataContext = createContext({})

export const useDataContext = (key, notFoundValue = {}) => {
  const context = useContext(DataContext)
  if (key) return context[key] || notFoundValue
  return context
}
